import { createFileRoute } from "@tanstack/react-router";

import SubscriptionPage from "@/components/[routes]/subscription/subscription-page";

export const Route = createFileRoute("/_secure/subscription")({
  component: SubscriptionPage,
});
